// extracted by mini-css-extract-plugin
module.exports = {"status-badge":"status-badge__status-badge___32_xP","statusBadge":"status-badge__status-badge___32_xP"};